<div class="container">
  <!-- Header usando componente shared -->
  <app-page-header
    title="Consultar Complemento"
    subtitle="Busca información de complementos por NIT"
    icon="addon">
  </app-page-header>

  <div class="form-alert form-alert--error" *ngIf="showAlertError">
    <i class="form-alert-icon">⚠</i>
    <span>{{ errorMessage }}</span>
  </div>
  <section class="user-consultation">
    <div class="form-container">
      <form class="form-wrapper" #consultationNitForm="ngForm" (ngSubmit)="onSubmit(consultationNitForm)">
        <div class="form-content">
          <div class="form-group">
            <label for="nit-input" class="form-label form-label--required">NIT</label>
            <input type="text" class="form-input" 
              [ngClass]="{'form-input--error': nitModel.invalid && nitModel.touched}"
              placeholder="Ingresa NIT" id="nitInput" [(ngModel)]="nitInput"
              name="nitInput" #nitModel="ngModel" required>
            <div *ngIf="nitModel.invalid && nitModel.touched" class="form-error-message">
              <i class="form-error-icon">&#9888;</i>
              <span class="form-error-text">Este campo es requerido!</span>
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button type="button" class="form-btn form-btn--cancel" 
            [ngClass]="{'is-active': nitModel.valid}"
            (click)="cancel(consultationNitForm)">Cancelar</button>
          <button type="submit" class="form-btn form-btn--submit" 
            [ngClass]="{'is-valid': nitModel.valid}"
            [disabled]="consultationNitForm.invalid">Consultar</button>
        </div>
      </form>
    </div>
  </section>
</div>

<!-- Modal de Resultados -->
<app-results-modal
  [isVisible]="showResultsModal"
  [title]="'Resultados'"
  [results]="resultsData"
  (closed)="closeResultsModal()">
</app-results-modal>